var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"icon"},[_c('use',{attrs:{"xlink:href":_vm.svgIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }